<template>
  <div :class="containerClassName">
    <slot name="label" :id="id" :label="label" :required="required">
      <label :for="id" v-if="!hideLabel">{{label}}<span v-if="required"> *</span></label>
    </slot>

    <div class="input-container" :class="inputContainerClasses" :data-symbol="symbol">
      <label v-if="inputLabel" class="label-input-title" :title="inputLabel">{{inputLabel | truncate(35)}}</label>
      <input
        :type="type"
        :id="id"
        :name="name"
        :value="value"
        :class="inputClasses"
        :disabled="disabled"
        :readonly="readonly"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :autofill="autofill"
        :autocomplete="autocomplete"
        @keydown="onKeydown"
        @input="onInput"
        @blur="onBlur"
        @focus="onFocus"
      >
      <span v-if="disabled || readonly" class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-disabled"></use></svg></span>
      <span class="form-error-label" v-if="errors.has(name)">
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
        {{ customErrorMessage ? customErrorMessage : errors.first(name) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheEmailInput',
  inject: [
    '$validator'
  ],
  props: {
    label: {
      type: String,
      default: ''
    },
    autofill: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: ''
    },
    customErrorMessage: {
      type: String,
      default: ''
    },
    containerClassName: {
      type: String,
      default: 'cell large-12'
    },
    id: {
      type: String,
      default: function () {
        return 'input-id-' + this._uid
      }
    },
    type: {
      type: String,
      default: 'email'
    },
    name: {
      type: String,
      default: null
    },
    value: {
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    symbol: {
      type: String,
      default: null
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: String,
      default: null
    },
    disabled: {
      type: [Boolean, Number],
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    inputLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    inputClasses: function () {
      let cls = []

      // Add the main class name
      cls.push(this.className)

      // Add disabled
      if (this.disabled) {
        cls.push('disabled')
      }

      // Add readonly
      if (this.readonly) {
        cls.push('readonly')
      }

      // Add error
      if (this.errors.has(this.name)) {
        cls.push('error')
      }

      return cls
    },
    inputContainerClasses: function () {
      let cls = []

      if (this.errors.has(this.name)) {
        cls.push('form-error')
      }

      if (this.disabled) {
        cls.push('disabled')
      }

      if (this.symbol) {
        cls.push('symbol-glyph')
      } else if (this.type === 'date') {
        cls.push('date')
      } else if (this.type === 'tel') {
        cls.push('tel')
      } else if (this.inputLabel) {
        cls.push('label-input')
      } else {
        cls.push('text')
      }

      return cls
    }
  },
  methods: {
    onKeydown: function (e) {
      /*
      If we want to prevent chars

      console.log(e.keyCode)
      if (e.keyCode === 71) {
        e.preventDefault()
      }
      */
    },
    onInput (e) {
      this.$emit('input', e.target.value)
    },
    onBlur (e) {
      this.$emit('blur')
    },
    onFocus (e) {
      this.$emit('focus')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Inputs/TheEmailInput.vue